import React from "react";
import Education from "./Subcomponent/Education";
import Job from "./Subcomponent/Job";
import Skills from "./Subcomponent/Skills";
import Certifications from "./Subcomponent/Certifications";
import Language from "./Subcomponent/Language";
import "../../Styles/resume.css";

const Resume = () => (
  <div className="container ">
    <div className="o-summary-box">
      <h2 className="o-summary-title">Professional Summary</h2>
      <p className="o-summary-text">
        Frontend Developer with 3+ years of experience building scalable,
        high-quality web applications using React, Next.js, JavaScript, and
        TypeScript. Strong background in responsive UI, performance, testing,
        analytics, and marketing-related implementations. Increasingly focused
        on GTM, automation, and growth systems that help businesses generate
        leads and improve conversion.
      </p>
    </div>
    <div className="o-res">
      <div className="col-sm-5 o-col-EI o-col-left">
        <div className="o-line1"></div>
        <Skills></Skills>
        <Language></Language>
        <Certifications></Certifications>
      </div>

      <div className="col-sm-7 o-col-EI o-col-right">
        <div className="o-line1"></div>
        <Education></Education>
        <Job></Job>
      </div>
    </div>
  </div>
);
export default Resume;
